import { useCallback, useEffect, useRef, useState } from 'react';
import { useThrottle } from '../useThrottle';
import { observeResize, unobserveResize } from '../utils/globalResizeObserver';
/**
 * This is the client only measure
 */ export function useMeasured(options = {}) {
    const refNode = useRef(null);
    const [dimensions, setDimensions] = useState({
        width: undefined,
        height: undefined
    });
    const updateDims = useThrottle((dims)=>{
        setDimensions(dims);
    }, [], options.throttle, options.throttleOptions);
    const resized = useCallback(([entry])=>{
        if (entry && entry.borderBoxSize) {
            const { inlineSize: width, blockSize: height } = entry.borderBoxSize[0];
            if (options.throttle) {
                updateDims({
                    width,
                    height
                });
            } else {
                setDimensions({
                    width,
                    height
                });
            }
        }
    }, [
        options.throttle,
        updateDims
    ]);
    const ref = useCallback((node)=>{
        if ((node === null || node === void 0 ? void 0 : node.nodeType) === Node.ELEMENT_NODE) {
            refNode.current = node;
            observeResize(node, resized);
        }
    }, [
        resized
    ]);
    useEffect(()=>{
        return ()=>{
            if (refNode.current) {
                unobserveResize(refNode.current, resized);
                refNode.current = null;
            }
        };
    }, [
        resized
    ]);
    return {
        ref,
        dimensions
    };
}
